module.exports = __webpack_public_path__ + "img/beer_id-21.0a343f87.png";